import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3c57c46e")

_pushScopeId("data-v-3c57c46e")
const _hoisted_1 = { class: "blank" }
const _hoisted_2 = {
  key: 0,
  class: "content"
}
const _hoisted_3 = {
  key: 1,
  class: "content"
}
const _hoisted_4 = {
  key: 2,
  class: "submit"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_text_area = _resolveComponent("a-text-area")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.jobView === "preview")
      ? (_openBlock(), _createBlock("div", _hoisted_2))
      : (_ctx.jobView === "see")
        ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.stuAnswer || '该题未作答'), 1))
        : (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode(_component_a_text_area, {
              value: _ctx.todoStu,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.todoStu = $event)),
              onChange: _ctx.todoSave
            }, null, 8, ["value", "onChange"])
          ]))
  ]))
})